@if (isLoading()) {
  <mat-progress-bar
    class="deliverable-detail-progress"
    mode="indeterminate"
    [dataSelector]="'cxp-deliverable-detail-loading-bar'"
  ></mat-progress-bar>
}

<div class="deliverable-detail-grid">
  <main class="deliverable-detail-main">
    @if (detail(); as detail) {
      <cxp-deliverable-detail-header
        [name]="detail.name"
        [serviceLineName]="detail.serviceLineName"
        [clientName]="detail.clientName"
        [description]="detail.description"
      />

      @if (isLoaded()) {
        <cxp-deliverable-files-list [deliverableId]="detail.id" [files]="detail.files" />
      }
    } @else if (hasError()) {
      <p class="deliverable-detail-status deliverable-detail-status--error" [dataSelector]="'cxp-deliverable-detail-error'">
        We couldn't load this deliverable. Please refresh and try again.
      </p>
    }
  </main>

  <div class="deliverable-detail-rail">
    <!-- Render sidebar once title is present; sections show "Loading" placeholders until payload arrives -->
    @if (detail(); as detail) {
      @if (detail.name) {
        <cxp-deliverable-details-sidebar
          [clientContacts]="detail.clientContacts"
          [teamMembers]="detail.teamMembers"
          [isLoading]="!isLoaded()"
        />
      }
    }
  </div>
</div>
